module.exports = __webpack_public_path__ + "img/slogan.bbb94ed9.webp";